import { Callout, Typography } from 'seagull';
import ContactSupportButton from "../../../components/ContactSupportButton";
import ExternalLinkButton from "../../../components/ExternalLinkButton";
import { PayoutFailureCode } from "../../../models";
import { helpArticles } from "../../../utils/helpArticles";
import styles from "./PayoutFailedCallout.module.scss";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
function getSuffix(code) {
  switch (code) {
    case PayoutFailureCode.MissingAuthorization:
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(ExternalLinkButton, {
          testId: "handling-chargebacks-link",
          openInNewTab: true,
          href: helpArticles.chargebacksAndDisputes('missing-auth'),
          children: "Learn more"
        }), ' ', "about handling chargebacks."]
      });
    default:
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: ["For assistance, please ", /*#__PURE__*/_jsx(ContactSupportButton, {
          testId: "contact-support"
        }), "."]
      });
  }
}
export default function PayoutFailedCallout(_ref) {
  let {
    payout,
    testId
  } = _ref;
  const payoutFailure = payout.payoutFailure();
  return payoutFailure ? /*#__PURE__*/_jsx(Callout, {
    testId: testId,
    intent: "warning",
    className: styles.payoutFailedCallout,
    children: /*#__PURE__*/_jsxs(Typography, {
      children: [/*#__PURE__*/_jsx(Typography, {
        weight: "bold",
        as: "span",
        children: "Payout failed."
      }), ' ', payoutFailure.message, " ", getSuffix(payoutFailure.code)]
    })
  }) : null;
}